export default {
    height: 'auto',
    calcHeight: 30,
    tip: false,
    searchShow: true,
    searchMenuSpan: 6,
    border: true,
    index: true,
    viewBtn: false,
    editBtn:false,
    delBtn:false,
    selection: true,
    dialogClickModal: false,
    searchLabelWidth: 120,
    column: [{
            label: "",
            prop: "id",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "合同分类",
            prop: "contractType",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=fasc_template",
            dataType: "number",
            labelWidth:140,
            props: {
                label: "dictValue",
                value: "dictKey"
            },
            search: true,
        },
        {
            label: "法大大控件ID",
            prop: "fieldId",
            type: "input",
            labelWidth:140,
            search: true,
        },
        {
            label: "法大大控件描术",
            prop: "fieldName",
            type: "input",
            labelWidth:140,
            search: true,
        },
        {
            label: "类属性名",
            prop: "propertyName",
            type: "select",
            search: true,
            dicUrl: "/api/blade-fascContractFieldMapping/fascContractFieldMapping/javaFascInfo",
            dataType: "string",
            slot: true,
            labelWidth:140,
            props: {
                label: "label",
                value: "propertyName"
            },
            change: (e) => {},
            dicFormatter: (row) => {
                let list = row.data.map(item => {
                    return {
                        ...item,
                        label: `${item.propertyDesc}-${item.propertyName}-${item.propertyType}`,
                    }
                })
                return list
            }
        },
        {
            label: "类属性名描述",
            prop: "propertyDesc",
            search: true,
            labelWidth:140,
            type: "input",
        },
        {
            label: "备用类属性名",
            prop: "propertyNameBak",
            type: "select",
            labelWidth:140,
            dicUrl: "/api/blade-fascContractFieldMapping/fascContractFieldMapping/javaFascInfo",
            dataType: "string",
            slot: true,
            props: {
                label: "label",
                value: "propertyName"
            },
            change: (e) => {},
            dicFormatter: (row) => {
                let list = row.data.map(item => {
                    return {
                        ...item,
                        label: `${item.propertyDesc}-${item.propertyName}-${item.propertyType}`,
                    }
                })
                return list
            }
        },
        {
            label: "备用类属性名描述",
            prop: "propertyDescBak",
            type: "input",
            labelWidth:140,
        },
        {
            label: "是否生效",
            prop: "isOff",
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_off",
            dataType: "number",
            labelWidth:140,
            props: {
                label: "dictValue",
                value: "dictKey"
            },
        },
        {
            label: "是否存在",
            prop: "isExist",
            type: "select",
            labelWidth:140,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_exist",
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
        },
        {
            label: "是否计算",
            prop: "isCompute",
            type: "select",
            labelWidth:140,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_compute",
            dataType: "number",
            props: {
                label: "dictValue",
                value: "dictKey"
            },
        },
        {
            label: "",
            prop: "tenantId",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "创建人",
            prop: "createUser",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "创建部门",
            prop: "createDept",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "修改人",
            prop: "updateUser",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "修改时间",
            prop: "updateTime",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "状态",
            prop: "status",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
        {
            label: "是否已删除",
            prop: "isDeleted",
            type: "input",
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            hide: true,
        },
    ]
}
